import React from 'react';

const defaultVal = {};
const CatalogContext = React.createContext(defaultVal);

export default CatalogContext;
